import {
  ScopeOfPracticeEnum,
  ShiftStatusEnum,
  ShiftTypeEnum,
} from '@umss/shared/utils';

/**
 * DTO for shift information.
 * Represents a scheduled shift for a contractor at a facility.
 */
export interface ShiftDto {
  id: string;
  facilityId: string;
  facilityName: string;
  contractorId: string;
  contractorName: string;
  scopeOfPractice: ScopeOfPracticeEnum;
  scopeOfPracticeDisplay: string;
  shiftType: ShiftTypeEnum;
  shiftTypeDisplay: string;
  shiftDate: string; // DateOnly from backend (YYYY-MM-DD format)
  startTime: string; // TimeOnly from backend (HH:mm:ss format)
  endTime: string; // TimeOnly from backend (HH:mm:ss format)
  hourlyRate: number;
  specialInstructions?: string;
  status: ShiftStatusEnum;
  statusDisplay: string;
  confirmedAt?: string;
  confirmedByName?: string;
  estimatedHours: number;
  estimatedPayment: number;
  createdAt: string;
  updatedAt: string;
}
